export default "__VITE_ASSET__C68sTMih__"